import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RespondentComponent } from './respondent.component';
import { PaginationModule } from '../project/pagination/pagination.module';
import { QuestionnaireModule } from '../project/questionnaire/questionnaire.module';
import { RespondentsOneByOneComponent } from './respondents-one-by-one.component';
import { RespondentsBySynchroComponent } from './respondents-by-synchro.component';
import { RespondentsByListComponent } from './respondents-by-list.component';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { SynchroPaginatePipeModule } from '../paginationPipe/synchro-paginate.pipe.module';
import {GenericModalModule} from '../modal/generic-modal.module';
import {DynamicDataModule} from '../dynamicData/dynamic-data.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        QuestionnaireModule,
        PaginationModule,
        TranslatePipeModule,
        SynchroPaginatePipeModule,
        GenericModalModule,
        DynamicDataModule
    ],
    declarations: [
        RespondentComponent,
        RespondentsOneByOneComponent,
        RespondentsBySynchroComponent,
        RespondentsByListComponent
    ],
    exports: [
        RespondentComponent,
        RespondentsOneByOneComponent,
        RespondentsBySynchroComponent,
        RespondentsByListComponent
    ]
})

export class RespondentsModule {

}
